import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../auth/service/auth.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, of } from 'rxjs';
import { ToastNotificationService } from '../../shared/notifications/toast.service';

@Injectable({
  providedIn: 'root'
})
export class GetUserService {
apiUrl: string = environment.apiUrl;
   testApi = 'https://test.api.tridimo.de/api/';
   devApi = 'https://dev.api.tridimo.de/api/';
   storedData: any

  constructor(private http: HttpClient, private authService: AuthService, private toastService: ToastNotificationService){}

   /**
   * Lädt gespeicherte Authentifizierungsdaten aus dem LocalStorage.
   * Wird zur Token- und User-Verarbeitung verwendet.
   */
  async getStoredData() {
    this.storedData = localStorage.getItem("authUser"); 
  }

    /**
   * Prüft, ob ein Token noch gültig ist.
   * Bei Ablauf wird automatisch ein Logout ausgelöst.
   */
  checkToken(token: any) {
    try {
      const expirationTime = token * 1000;
      const currentTime = Date.now();
      if (currentTime > expirationTime) {
        console.log('Token ist älter als 60 Minuten');
        this.logout()
      } else {
        console.log('Token ist noch gültig');
      }
    } catch (e) {
      console.error('Fehler beim Dekodieren des Tokens:', e);
      this.logout()
    }
  }

  /**
   * Meldet den Benutzer vollständig ab.
   * Löscht lokale Daten und ruft den AuthService Logout auf.
   */
  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.authService.logout();
  }

  /**
   * Erstellt die HTTP-Optionen für API-Requests.
   * Fügt je nach Umgebung Token oder Credentials hinzu.
   */
setFetchOptions(): { headers?: HttpHeaders; withCredentials?: boolean } {
  let options: { headers?: HttpHeaders; withCredentials?: boolean } = {};

  if (this.apiUrl === this.devApi) {
    let token = '';
    this.getStoredData();
    if (this.storedData) {
      try {
        const parsedData = JSON.parse(this.storedData);
        token = parsedData.token;
        this.checkToken(parsedData.exp);
      } catch {
        this.logout();
      }
    } else {
      this.logout();
    }

    options.headers = new HttpHeaders({
      Authorization: `${token}`,
      'Content-Type': 'application/json'
    });
  } else {
    options.withCredentials = true;
  }

  return options;
}

  /**
   * Holt die Daten des aktuell eingeloggten Users.
   * Behandelt Fehler wie fehlende Authentifizierung automatisch.
   */
fetchUser() {
    const options = this.setFetchOptions();
    // console.log('FETCH OPTIONS: ',options)
    return this.http.get(`${this.apiUrl}user`, options).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // console.log("Unauthorized: Logging out");
          this.toastService.dangerToast(`Fehler beim laden der User Daten, kein Token gefunden`);
          this.logout();  // Falls 401, führe logout aus
        } else {
          this.toastService.dangerToast(`Fehler beim laden der User Daten`);
        }
     
        return of(null);
      })
    );
  }

    /**
   * Lädt das Profilbild des Users.
   * Fallback auf Standardbild bei Fehler.
   */
loadUserIcon(): Observable<Blob> {
    const userEmail = JSON.parse(localStorage.getItem('authUser') || '{}')?.user?.email || '';
    const options: any = this.setFetchOptions();

    if (this.apiUrl === this.devApi) {
      const headers = options.headers
        ?.delete('Content-Type')
        ?.set('Accept', 'image/*');

      return this.http.get(
        `${this.apiUrl}user/profile/o365/photo/${userEmail}`,
        {
          headers: headers,
          responseType: 'blob'
        }
      ).pipe(
        catchError(() => {
          // Silent fallback, kein console.error
          return this.http.get('/assets/icons/user.png', { responseType: 'blob' });
        })
      );

    } else {
      return this.http.get(
        `${this.apiUrl}user/profile/o365/photo/${userEmail}`,
        {
          responseType: 'blob',
          withCredentials: true
        }
      ).pipe(
        catchError(() => {
          // Silent fallback, kein console.error
          return this.http.get('/assets/icons/user.png', { responseType: 'blob' });
        })
      );
    }
  }

    /**
   * Lädt eine Liste von Ressourcen/Interpretern vom Backend.
   * Nutzt zentrale Error-Handling-Logik mit Toast-Meldungen.
   */
fetchInterpreters() {
    const options = this.setFetchOptions();
    // console.log('FETCH OPTIONS: ',options)
    //return this.http.get(`${this.apiUrl}resources/dolmetscher`, options).pipe(
    return this.http.get(`${this.apiUrl}resources`, options).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // console.log("Unauthorized: Logging out");
          this.toastService.dangerToast(`Fehler beim laden der Resourcen, kein Token gefunden`);
          this.logout();  // Falls 401, führe logout aus
        } else {
          this.toastService.dangerToast(`Fehler beim laden der Resourcen`);
        }
        return of(null);
      })
    );
  }
}
